import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ProducerProfileForm from "@/components/forms/ProducerProfileForm";

export default function ProducerOnboardingPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="max-w-2xl mx-auto px-6 py-12 sm:py-16">
      <div className="mb-8 rounded-2xl bg-[#4ba3b7]/10 border border-[#4ba3b7]/20 p-4 text-sm text-[#2B2B2B]/80" data-testid="producer-onboarding-banner">
        {t("auth.verificationBanner")}
      </div>
      <div className="bg-white rounded-2xl border border-black/5 shadow-[0_4px_24px_rgba(0,0,0,0.03)] p-6 sm:p-8">
        <ProducerProfileForm />
      </div>
      <button
        onClick={() => navigate("/dashboard/producer")}
        className="block mx-auto mt-6 text-sm text-[#2B2B2B]/50 hover:underline"
        data-testid="producer-onboarding-skip-link"
      >
        {t("common.close")}
      </button>
    </div>
  );
}
